import React from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";

import KpiNumberTile from "./KpiNumberTile";
import { nv, periodDelta } from "./utils";
import { useTrendsData } from "./hooks/useTrendsData";

const pick = (s) => {
    const i = s.indexabilityStats || {};
    return (i.metaNoIndex || 0) + (i.canonicalized || 0) + (i.blockedByRobotsTxt || 0) + (i.xRobotsNoIndex || 0);
};

export default function KpiIndexabilityTile({ startDate, endDate, lastN, onFilter, onInvestigate }) {
    const { workspaceNumber } = useParams();
    const live = useSelector((s) => s.stats?.workspaceStats);
    const { series, days } = useTrendsData({ workspaceNumber, startDate, endDate, lastN });

    const value = pick(live || {});
    const ix = live?.indexabilityStats || {};

    return (
        <KpiNumberTile
            title="Non-indexable"
            info="Pages excluded from indexing right now: meta noindex, canonicalised, robots.txt blocked, X-Robots noindex. Down = good."
            tone={value > 0 ? "#b45309" : undefined}
            sparkColor="#b45309"
            value={live?.fetched ? value : "—"}
            valueTooltip={live?.fetched
                ? `Meta: ${nv(Number(ix.metaNoIndex || 0))} • Canon: ${nv(Number(ix.canonicalized || 0))} • Robots: ${nv(Number(ix.blockedByRobotsTxt || 0))} • XR: ${nv(Number(ix.xRobotsNoIndex || 0))}`
                : undefined}
            delta={periodDelta(value, days, pick)}
            sparkSeries={series(pick)}
            onFilter={onFilter}
            onInvestigate={onInvestigate}
        />
    );
}
